import React, { useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import { InputV2, RadioGroupPod, SelectV } from 'components';
import { useForm } from 'react-hook-form';
import isEmpty from 'lodash/isEmpty';

const BodyForm = ({ onClick, data = {}, action }) => {
  const { register, watch, control, formState: { errors }, trigger, reset, getValues } = useForm();

  const submit = async () => {
    const valid = await trigger([
      'scInputParams.scParameterName',
      'scInputParams.scParameterAlias',
      'scInputParams.scParameterType',
      'scInputParams.typeOfBody',
      'scInputParams.scParameterDefaultValue',
      //
      //
      'scInputParams.scParameterDesc',
    ]);

    if (valid) {
      const typeOfBody = {
        optional: {
          scHiddenParameter: false,
          scIsRequired: false,
        },
        required: {
          scHiddenParameter: false,
          scIsRequired: true,
        },
        hidden: {
          scHiddenParameter: true,
          scIsRequired: false,
        },
      };

      let dataForm = {
        scParameterName: getValues('scInputParams.scParameterName'),
        scParameterAlias: getValues('scInputParams.scParameterAlias'),
        scParameterType: getValues('scInputParams.scParameterType'),
        scParameterDefaultValue: getValues('scInputParams.scParameterDefaultValue'),
        scParameterDesc: getValues('scInputParams.scParameterDesc'),
        scParameterLogMode: getValues('scInputParams.scParameterLogMode'),
        scSelfClose: getValues('scInputParams.scSelfClose'),
      };

      if (getValues('scInputParams.typeOfBody') === 'required') {
        dataForm.defaultValue = '';
      }

      dataForm = {
        ...dataForm,
        ...typeOfBody[getValues('scInputParams.typeOfBody')],
      };

      onClick(dataForm, action);
    }
  };

  const getTypeOf = (scHiddenParameter, scIsRequired) => {
    if (scHiddenParameter === false && scIsRequired === false) {
      return 'optional';
    }
    if (scHiddenParameter === false && scIsRequired === true) {
      return 'required';
    }
    if (scHiddenParameter === true && scIsRequired === false) {
      return 'hidden';
    }
  };

  useEffect(() => {
    if (!isEmpty(data)) {
      const typeOfBody = getTypeOf(data.scHiddenParameter, data.scIsRequired);
      const dataForm = { ...data, typeOfBody };
      reset({ scInputParams: dataForm });
    }
  }, []);

  const valTypeOfBody = watch('scInputParams.typeOfBody');

  return (
    <Grid container direction="row" alignItems="center" spacing={2} item xs={12}>
      <Grid item xs={12}>
        {/* <Typography>پارامتر والد</Typography> */}
      </Grid>

      <Grid item xs={6}>
        <InputV2
          label="نام پارامتر"
          fullWidth
          errors={errors}
          name="scInputParams.scParameterName"
          register={register}
          rules={['required']}
          control={control}
          margin="dense"
        />
      </Grid>
      <Grid item xs={6}>
        <InputV2
          fullWidth
          label="نام مستعار"
          errors={errors}
          name="scInputParams.scParameterAlias"
          register={register}
          control={control}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectV
          label="نوع پارامتر"
          name="scInputParams.scParameterType"
          options={[
            { value: 'String', label: 'String' },
            { value: 'Route', label: 'Route' },
            { value: 'JSon', label: 'JSon' },
            { value: 'Array', label: 'Array' },
            { value: 'XML', label: 'XML' },
            { value: 'Raw', label: 'Raw' },
          ]}
          control={control}
          rules={['required']}
          errors={errors}
          fullWidth
          defaultValue="String"
          margin="dense"
        />
      </Grid>

      <Grid item xs={6}>
        <SelectV
          label="نوع ورودی"
          name="scInputParams.typeOfBody"
          options={[
            { value: 'optional', label: 'اختیاری' },
            { value: 'required', label: 'اجباری' },
            { value: 'hidden', label: 'مخفی' },
          ]}
          control={control}
          rules={['required']}
          errors={errors}
          fullWidth
          defaultValue="optional"
          margin="dense"
        />
      </Grid>

      <Grid item xs={12}>
        {valTypeOfBody === 'required' ? (
          <InputV2
            label="مقدار پیش فرض"
            errors={errors}
            name="scInputParams.scParameterDefaultValue"
            register={register}
            fullWidth
            control={control}
            margin="dense"
            disabled
          />
        ) : (
          <InputV2
            label="مقدار پیش فرض"
            errors={errors}
            name="scInputParams.scParameterDefaultValue"
            register={register}
            rules={['required']}
            fullWidth
            control={control}
            margin="dense"
          />
        )}
      </Grid>

      <Grid item xs={12}>
        <RadioGroupPod
          label="وضعیت لاگ"
          control={control}
          name="scInputParams.scParameterLogMode"
          defaultValue="LOGGABLE"
          options={[
            { value: 'LOGGABLE', label: 'LOGGABLE', placement: 'end' },
            { value: 'NOT_LOGGABLE', label: 'NOT_LOGGABLE', placement: 'end' },
            { value: 'MASK', label: 'MASK', placement: 'end' },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <RadioGroupPod
          label="آیا تگ بسته شود؟"
          control={control}
          name="scInputParams.scSelfClose"
          defaultValue="true"
          options={[
            { value: 'true', label: 'بله', placement: 'end' },
            { value: 'false', label: 'خیر', placement: 'end' },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <InputV2
          label="شرح"
          fullWidth
          errors={errors}
          name="scInputParams.scParameterDesc"
          register={register}
          rules={['required']}
          control={control}
          multiline
          rows={4}
          margin="dense"
        />
      </Grid>
      <Grid coantainer xs={12} direction='row-reverse' style={{display:'flex'}}>
        <Button color="primary" variant="contained" onClick={submit}>
          ساخت پارامتر
        </Button>
      </Grid>
    </Grid>
  );
};

export default BodyForm;
